import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { AccountPortfolioDTO } from '../../../../../Profile/Accounts/api/useAccountPortfolioQuery';
import { InsuranceData } from '../../../useInsurance';
import { AssetAllocationStackChart } from './components/AssetAllocationStackChart/AssetAllocationStackChart';
import { AssetAllocationTable } from './components/AssetAllocationTable/AssetAllocationTable';
import { AssetsAllocationTableTotal } from './components/AssetsAllocationTableTotal/AssetsAllocationTableTotal';
import { HypotheticalReturn } from './components/HypotheticalReturn/HypotheticalReturn';

interface ContentProps {
  accountPortfolio?: AccountPortfolioDTO;
  data: InsuranceData;
}

export const AssetAllocation = ({ accountPortfolio }: ContentProps) => {
  return (
    <>
      {accountPortfolio?.ShowHypotheticalReturn && (
        <Box py="16" maxWidth="50%">
          <HypotheticalReturn />
        </Box>
      )}

      <Box py="16">
        <Text fontWeight={600}>Monte Carlo Simulation Asset Allocation</Text>

        <Box pt="8">
          <AssetAllocationStackChart />
        </Box>
      </Box>

      <AssetAllocationTable />

      <AssetsAllocationTableTotal />
    </>
  );
};
